export const Logo = ({ light = false, size = "md" }) => {
  const h = size === "lg" ? "h-16" : size === "sm" ? "h-9" : "h-12";
  return (
    <img
      src="/ch-logo.webp"
      alt="CH CREATIVE"
      data-testid="ch-logo"
      className={`${h} w-auto object-contain ${light ? "brightness-0 invert" : ""}`}
    />
  );
};
